import React from 'react';
import { socialPlatforms } from '../../utils/socialPlatforms';
import { getEmbedUrl, getEmbedLabel } from '../../utils/embedUtils';

/* ─── Inline embed card (YouTube / Spotify / TikTok / …) ─── */
export const EmbedPlayer = ({ link, themeStyles }) => {
  const embed = getEmbedUrl(link.url);
  if (!embed) return null;
  const ts = themeStyles;
  const platform = socialPlatforms.find(p => p.id === link.platform);
  const Icon = platform?.icon;

  return (
    <div className="rounded-xl overflow-hidden" style={{
      background: ts['--theme-card'],
      border: `1px solid ${ts['--theme-card-border']}`
    }} data-testid={`embed-${link.id}`}>
      <div className="p-3 pb-2 flex items-center space-x-3">
        {Icon && (
          <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${link.color}20` }}>
            <Icon className="w-4 h-4" style={{ color: link.color }} />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm truncate" style={{ color: ts['--theme-text'] }}>{link.title}</p>
          <p className="text-xs" style={{ color: ts['--theme-text-muted'] }}>{getEmbedLabel(link.url) || link.platformName}</p>
        </div>
      </div>
      <div className="px-3 pb-3">
        <div className="rounded-lg overflow-hidden" style={embed.aspectRatio ? { aspectRatio: embed.aspectRatio } : { height: embed.height || 300 }}>
          <iframe
            src={embed.embedUrl}
            title={link.title}
            className="w-full h-full border-0 rounded-lg"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};
